import { gql } from "@apollo/client";

export const GET_ORGANIZATIONS_BY_GRADES_CONFIG = gql`
  query GetOrganizationsByGradesConfig {
    organization(order_by: [{ path: asc }]) {
      id
      path
      grade_configs(order_by: [{ order: asc }]) {
        id
        label
        order
        value
      }
    }
  }
`;

export const GET_ORG_GRADES_CONFIG_BY_PK = gql`
  query GetOrgGradesConfigByPk($id: uuid!) {
    organization_by_pk(id: $id) {
      id
      grade_configs(order_by: [{ order: asc }]) {
        id
        label
        order
        value
      }
    }
  }
`;
